import logoFacebook from "@/assets/login/facebook.png";
import logoInstagram from "@/assets/login/instagram.png";
import logoLinkedin from "@/assets/login/linkedin.png";
import welcomeToTheFuture from "@/assets/login/welcome_to_the_future.png";
import logoYoutube from "@/assets/login/youtube.png";
import Box from "../Box";

export const WelcomeToTheFuture = (
  <Box
    sx={{
      flexDirection: "row",
      display: { xs: "none", md: "flex" },
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <img src={welcomeToTheFuture} height="48px" alt="Welcome to the future" />
    </Box>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        m: 2,
        gap: 2,
        alignItems: "center",
      }}
    >
      <a
        href="https://www.linkedin.com/company/gatti-filtrazioni-lubrificanti/"
        target="_blank"
      >
        <img src={logoLinkedin} width="32" height="32" />
      </a>
      <a
        href="https://www.facebook.com/Gattifiltrazionilubrificanti/"
        target="_blank"
      >
        <img src={logoFacebook} width="32" height="32" />
      </a>
      <a
        href="https://www.instagram.com/gattifiltrazionilubrificanti/"
        target="_blank"
      >
        <img src={logoInstagram} width="32" height="32" />
      </a>
      <a
        href="https://www.youtube.com/channel/UCx6aUZ_JiM-EK2e_mQ8-vTg/videos"
        target="_blank"
      >
        <img src={logoYoutube} width="32" height="32" />
      </a>
    </Box>
  </Box>
);
